(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categories"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const tabs = document.querySelectorAll('.tabbed-collections [data-tab]');
    const carousels = document.querySelectorAll('.tabbed-collections [data-carousel]');

    tabs.forEach(tab => {
      tab.addEventListener('click', function () {
        const tabName = this.getAttribute('data-tab');

        tabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');

        carousels.forEach(carousel => {
          carousel.classList.toggle(
            'active',
            carousel.getAttribute('data-carousel') === tabName
          );
        });
      });
    });

    carousels.forEach(carousel => {
      const inner = carousel.querySelector('[data-carousel-inner]');
      const range = carousel.querySelector('[data-scroll-range]');
      const prev = carousel.querySelector('[data-prev]');
      const next = carousel.querySelector('[data-next]');

      if (!inner || !range || !prev || !next) return;

      function updateRange() {
        const maxScroll = inner.scrollWidth - inner.clientWidth;
        range.value = maxScroll > 0
          ? Math.round((inner.scrollLeft / maxScroll) * 100)
          : 0;
      }

      range.addEventListener('input', function () {
        const maxScroll = inner.scrollWidth - inner.clientWidth;
        inner.scrollLeft = (Number(this.value) / 100) * maxScroll;
      });

      inner.addEventListener('scroll', updateRange, { passive: true });

      prev.addEventListener('click', () => {
        inner.scrollBy({ left: -inner.clientWidth * 0.75, behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        inner.scrollBy({ left: inner.clientWidth * 0.75, behavior: 'smooth' });
      });

      window.addEventListener('resize', updateRange);
      updateRange();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
